import { Component, ElementRef } from "@angular/core";
import { MeetingAgendaItem } from "@common/ADAPT.Common.Model/organisation/meeting-agenda-item";
import { Team, TeamBreezeModel } from "@common/ADAPT.Common.Model/organisation/team";
import { CommonDataService } from "@common/lib/data/common-data.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { IMeetingAgendaItemComponent, MeetingAgendaItemComponent } from "@org-common/lib/meetings/meeting-agenda-component-registry";
import { lastValueFrom } from "rxjs";

@MeetingAgendaItemComponent("adapt-team-roles-meeting-agenda-item")
@Component({
    selector: "adapt-team-roles-meeting-agenda-item",
    standalone: false,
    styleUrl: "./team-roles-meeting-agenda-item.component.css",
    templateUrl: "./team-roles-meeting-agenda-item.component.html",
})
export class TeamRolesMeetingAgendaItemComponent extends BaseComponent implements IMeetingAgendaItemComponent {
    public meetingAgendaItem?: MeetingAgendaItem;
    public team?: Team;

    public constructor(
        private commonDataService: CommonDataService,
        elementRef: ElementRef,
    ) {
        super(elementRef);
    }

    public async onDataChanged() {
        if (this.meetingAgendaItem?.meeting) {
            this.team = this.meetingAgendaItem.meeting.team ??
                await lastValueFrom(this.commonDataService.getById(TeamBreezeModel, this.meetingAgendaItem.meeting.teamId));
        }
    }
}
